import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/webnode/app/eduline-web/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webnode/app/eduline-web/src/app/dashboard/components/DashboardHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webnode/app/eduline-web/src/app/dashboard/components/KPIBentoGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webnode/app/eduline-web/src/app/dashboard/components/MonthlyLineChart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webnode/app/eduline-web/src/app/dashboard/components/ProgramBarChart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webnode/app/eduline-web/src/app/dashboard/components/RecentApplicants.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webnode/app/eduline-web/src/app/dashboard/components/StatusDonutChart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webnode/app/eduline-web/src/components/AppLayout.tsx");
